import React, { useEffect, useState } from 'react';
import {
  FormControl,
  Grid,
  Typography,
  TextField,
  Autocomplete,
  Paper,
} from '@mui/material';
import Stack from '@mui/material/Stack';
import { CloseCircle } from 'iconsax-react';
import { useCompany } from 'hooks';
const allStatus = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
];

const Search = ({ filter, setFilter, isManagement = false }) => {
  const { locations } = useCompany();
  const allLocations = [
    {
      value: '0',
      label: locations && locations.length === 0 ? 'None' : 'All',
    },
    ...(locations || []).map((loc) => ({ value: loc._id, label: loc.location })),
  ];
  const handleAutocompleteChange = (name, newValue) => {
    setFilter({
      ...filter,
      [name]: newValue,
    });
  };
  return (
    <Paper className="searchh">
      <Grid container spacing={3} alignItems="center">
        {!isManagement ? <Grid item xs={6} md={2}>
          <Stack spacing={1}>
            <Typography variant="subtitle1" className="label">
              Location
            </Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={allLocations}
                getOptionLabel={(option) => option.label}
                value={filter.location}
                onChange={(event, newValue) =>
                  handleAutocompleteChange('location', newValue ? newValue : { value: '0', label: 'All' })
                }
                renderInput={(params) => <TextField {...params} placeholder="Select Location" variant="outlined" />}
                clearIcon={<CloseCircle style={{ color: 'red' }} />} // Custom clear icon
              />
            </FormControl>
          </Stack>
        </Grid> : ""}
        <Grid item xs={6} md={2}>
          <Stack spacing={1}>
            <Typography variant="subtitle1" className="label">
              Status
            </Typography>
            <FormControl fullWidth>
              <Autocomplete
                options={allStatus}
                getOptionLabel={(option) => option.label}
                value={filter.status}
                onChange={(event, newValue) =>
                  handleAutocompleteChange('status', newValue ? newValue : { value: 'Active', label: 'Active' })
                  // handleAutocompleteChange('status', newValue)
                }

                renderInput={(params) => <TextField {...params} placeholder="Select Care Manager" variant="outlined" />}
                clearIcon={<CloseCircle style={{ color: 'blue' }} />} // Custom clear icon
              />
            </FormControl>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Search;
